
export const errorHandle = (process) => {
    return function(){
        try {
            return process.apply(this, arguments);
        } catch (e) {
            if (e) {
                e.setState({isProgress: false});
                e.props.openSnackbar(e.props.intl.formatMessage({ id: "errCode_10006" }));    
            }
        }
    };
}

export default errorHandle;
